<script setup lang="ts">
const total = ref(0)
const isLoading = ref(false)
</script>

<template>
  <div>
    <div class="wfull">
      <div class="mb6">
        <ProductsGrid
          @total="(v) => (total = v)"
          @loading="(loading) => (isLoading = loading)"
        />
      </div>
    </div>
  </div>
</template>
